import { createContext, useContext } from 'react';

const AuthContext = createContext({
  keycloak: null,
  initialized: false,
  authenticated: false,
  userInfo: null,
  isWhitelisted: false,
  isAdmin: false,
  login: () => {},
  logout: () => {},
  register: () => {},
});

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
